import React, { useEffect, useState } from 'react';
import { Row, Col, Card, CardBody, CardHeader, Container, FormGroup, Label } from 'reactstrap';
import moment from 'moment';
import PageDataLoader from '../Utility/PageDataLoader';
import ThumbnailGallery from './ThumbnailGallery';
import { getBatchImageList } from '../../api/batchImage';
import { connect } from 'react-redux';
import Breadcrumbs from '../../components/Common/Breadcrumb';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { AvField, AvForm } from 'availity-reactstrap-validation';

function TodaysImagesPage(props) {
  const [breadcrumbItems] = useState([
    { title: 'Batches', link: '/batches' },
    { title: 'Todays Images', link: '#' }
  ]);

  const [todayImagesLoading, setTodayImagesLoading] = useState(false);
  const [todayImages, setTodayImages] = useState([]);
  const [open,setOpen] = useState(null);

  const [exactDate, setExactDate] = useState(new Date());
  const createQueryOptions = (date = exactDate) => {
    return {
      filter_exact_date: date ? new Date(date) : '',
    };
  };

  const fetchTodayImages = async (selectedDate = exactDate) => {
    setTodayImagesLoading(true);

    try {
      const response = await getBatchImageList({
        page: 1,
        limit: 1000,
        ...createQueryOptions(selectedDate),
      });

      if (response) {
        const data = response.data || [];
        setTodayImages(data);

        const allIds = data.map(item => item._id);
        setOpen(allIds.length > 0 ? allIds[0] : null);

        setTodayImagesLoading(false);
      }
    } catch (error) {
      setTodayImagesLoading(false);
    }
  };

  // Check if batch is open
  const isBatchOpen = (id) => {
    return open === id;
  };

  // Toggle batch open/close
  const toggleBatch = (id) => {
    setOpen(prev => (prev === id ? null : id));
  };

  useEffect(() => {
    fetchTodayImages(exactDate);
  }, [exactDate]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title="Todays Images"
            breadcrumbItems={breadcrumbItems}
          />
          <Row>
            <Col>
              <Card>
                <CardBody>
                  <Row className="mb-3">
                    <Col md="3">
                      <AvForm>
                      <FormGroup>
                        <Label>Date</Label>
                        <AvField
                          name="exactDate"
                          type="date"
                          className="form-control"
                          value={moment(exactDate).format('YYYY-MM-DD')}
                          onChange={(e) => {
                            const selected = e.target.value
                              ? new Date(e.target.value)
                              : null;

                            setExactDate(selected);
                          }}
                        />
                      </FormGroup>
                    </AvForm>
                    </Col>
                  </Row>
                  <Row className="mt-2">
                    <Col md="12">
                      {todayImagesLoading ? (
                        <div className="text-center">
                          <PageDataLoader />
                        </div>
                      ) : todayImages?.length > 0 ? (
                        todayImages.map((item) => (
                          <Card key={item._id} className="mb-3">

                            {/* Clickable Header */}
                            <Card
                              onClick={() => toggleBatch(item._id)}
                              style={{ cursor: "pointer" }}
                            >
                              <CardBody className="d-flex justify-content-between align-items-center">
                                <span>{item.batch?.name}</span>
                                <span>
                                  {isBatchOpen(item._id) ? "▲" : "▼"}
                                </span>
                              </CardBody>
                            </Card>

                            {/* Dropdown Content */}
                            {isBatchOpen(item._id) && (
                              <CardBody>
                                {item.images?.length > 0 ? (
                                  <ThumbnailGallery
                                    images={item.images}
                                    fetchNewData={() => fetchTodayImages(exactDate)}
                                    authUser={props.authUser}
                                  />
                                ) : (
                                  <Card className="text-center">
                                    <CardBody>No images in this batch</CardBody>
                                  </Card>
                                )}
                              </CardBody>
                            )}

                          </Card>
                        ))
                      ) : (
                        <Card className="text-center">
                          <CardBody>
                            No images found for{' '}
                            {moment(exactDate).format('DD MMM YYYY')}
                          </CardBody>
                        </Card>
                      )}
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
}

const mapStateToProps = (state) => {
  return {
    authUser: state.Login?.user
  };
};

export default connect(mapStateToProps)(TodaysImagesPage);
